import { merge as _merge } from 'lodash'
import ro from 'core/translations/ro'

export default _merge(ro, {
  error: {
    GUCCI_ERROR_PRODUCT_VARIANT: 'SKU variantă. Folosește operațiunea Codificare LG de eșantionare.',
    GUCCI_ERROR_PRODUCT_NOT_VARIANT: 'SKU fără variantă. Folosește operațiunea Codificare LG.',
    GUCCI_SHOES_ERROR_PRODUCT_VARIANT: 'SKU variantă. Folosește operațiunea Codificare încălțăminte de eșantionare.',
    GUCCI_SHOES_ERROR_PRODUCT_NOT_VARIANT: 'SKU fără variantă. Folosește operațiunea Codificare încălțăminte.',
    GUCCI_ERROR_PRODUCT_MISSING_EAN: 'SKU fără variantă, EAN lipsă. Nu se poate continua. Contactează asistența.'
  },
  custom: {
    NFC_PRODUCT_NOT_ALLOWED: 'SKU-ul necesită un tag NFC. Folosește funcționalitatea Control produs.'
  }
})
